/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { HTMLAttributes } from 'react';
import { colors } from '@airwallex/global';
import LanguageSelect from './mobileLanguage';
import { logoContainerCss, logoImgCss } from './style';

const { softGrey, darkGrey } = colors;

export type MobileHeaderProps = {
  logoUrl?: string;
  haveLanguageChoice?: boolean;
  hideBorder?: boolean;
};

export const selectCss = css`
  width: 280px;
  height: 40px;
  margin-left: 8px;
`;

export const Index: React.FC<MobileHeaderProps & HTMLAttributes<HTMLDivElement>> = ({
  logoUrl,
  haveLanguageChoice,
  hideBorder,
}) => {
  return (
    <div
      css={css`
        height: ${haveLanguageChoice && '56px'};
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        ${!hideBorder && `border-bottom: 1px solid ${softGrey};`}
        z-index: 1000;
      `}
    >
      <h5
        css={css`
          color: ${darkGrey};
          margin: 0 auto;
          padding: 0 16px;
        `}
      >
        <div
          css={css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: ${haveLanguageChoice && '56px'};
          `}
        >
          {logoUrl ? (
            <div css={logoContainerCss} style={{ justifyContent: 'flex-start' }}>
              <img src={decodeURIComponent(logoUrl)} alt="merchant-logo" css={logoImgCss} />
            </div>
          ) : (
            <div />
          )}
          {haveLanguageChoice && <LanguageSelect />}
        </div>
      </h5>
    </div>
  );
};

export default Index;
